export const environment = {
  production: false,
  basePath: 'https://fandsdevapi.mi2.in/api',
  tenant: 'tenantdev00001',
  supportedCountry: ['IN', 'UK', 'US'],
};
